export default function Page({ wide = false, className = '', children }) {
  return <div className={`cn-page ${wide ? 'cn-page--wide' : ''} ${className}`.trim()}>{children}</div>
}

export function PageHeader({ title, chip, actions, children }) {
  return (
    <div className="cn-page-header">
      {chip}
      <h1 className="cn-page-title">{title}</h1>
      {children}
      {actions && <div className="cn-page-actions">{actions}</div>}
    </div>
  )
}
